
import React from 'react';
import { X } from 'lucide-react';

interface MotivationalTitleBarProps {
  title: string;
  onDismiss: () => void;
}

export const MotivationalTitleBar = ({ title, onDismiss }: MotivationalTitleBarProps) => {
  return (
    <div 
      className="flex items-center justify-between p-2 text-sm font-bold border-b"
      style={{
        backgroundColor: 'var(--popup-title-bg)',
        color: 'var(--popup-text)',
        borderColor: 'var(--popup-border)'
      }}
    >
      <span className="flex-1 truncate">{title}</span>
      <button
        onClick={onDismiss}
        className="ml-2 flex h-4 w-4 items-center justify-center hover:bg-red-600 transition-colors"
        style={{ backgroundColor: 'rgba(255,0,0,0.2)' }}
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};
